<!-- Skeleton de loading -->
<div *ngIf="loading" class="titulos-skeleton">
  <p-skeleton *ngFor="let i of [1, 2, 3]" width="100%" height="90px" borderRadius="12px" styleClass="mb-3"></p-skeleton>
</div>

<!-- Empty State -->
<div *ngIf="!loading && titulos.length === 0" class="empty-state">
  <i class="pi pi-inbox empty-state-icon"></i>
  <p>{{ labels.nenhum_resultado }}</p>
</div>

<!-- Lista de Cards de Titulos -->
<div *ngIf="!loading && titulos.length > 0" class="titulos-lista">
  <div class="titulo-card" *ngFor="let titulo of titulos"
    [ngClass]="config.tipo === 'SAIDA' ? 'borda-saida' : 'borda-entrada'">

    <!-- Linha principal: info + valor destaque + seta -->
    <div class="titulo-card-main" (click)="onTituloClick(titulo)">
      <div class="titulo-card-info">
        <div class="titulo-nome">
          <i class="pi pi-file-edit"></i>
          <span>#{{ titulo.codigoTitulo || titulo.id }}</span>
          <span class="titulo-pessoa-nome" *ngIf="titulo.nomePessoa">- {{ titulo.nomePessoa }}</span>
        </div>
        <div class="titulo-detalhes">
          <span class="titulo-vencimento">
            <i class="pi pi-calendar"></i>
            {{ labels.vencimento }}: {{ formatarVencimento(titulo.vencimento) }}
          </span>
          <span class="titulo-valor-original" *ngIf="titulo.valor > 0">
            {{ labels.valor }}: {{ formatarValor(titulo.valor, titulo.moeda) }}
          </span>
        </div>
        <div class="titulo-badges">
          <span class="titulo-parcela" *ngIf="titulo.numeroParcela">
            {{ labels.parcela }}: {{ titulo.numeroParcela }}
          </span>
          <span class="badge-situacao"
            [ngClass]="getSituacao(titulo) === 'PAGO' ? 'badge-pago'
                       : (getSituacao(titulo) === 'CANCELADO' ? 'badge-cancelado' : 'badge-aberto')">
            {{ getSituacao(titulo) === 'PAGO' ? labels.pago
               : (getSituacao(titulo) === 'CANCELADO' ? labels.cancelado : labels.aberto) }}
          </span>
        </div>
      </div>
      <div class="titulo-card-valor">
        <span class="titulo-valor-destaque"
          [ngClass]="situacao === 'PAGO' ? 'valor-pago' : 'valor-aberto'">
          {{ situacao === 'PAGO'
            ? (calcularTotalPago(titulo) > 0 ? formatarValor(calcularTotalPago(titulo), titulo.moeda) : formatarValor(titulo.valor, titulo.moeda))
            : formatarValor(titulo.saldo, titulo.moeda) }}
        </span>
      </div>
      <div class="titulo-card-arrow">
        <i class="pi pi-chevron-right"></i>
      </div>
    </div>

    <!-- Pagamentos parciais expandiveis -->
    <div class="titulo-pagamentos" *ngIf="temPagamentos(titulo)">
      <button pButton type="button"
        class="p-button-text p-button-sm btn-toggle-pagamentos"
        [icon]="expandedRows[titulo.id] ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
        [label]="labels.pagamentos_titulo"
        (click)="toggleExpand(titulo)">
      </button>
      <div *ngIf="expandedRows[titulo.id]" class="pagamentos-list">
        <div class="pagamento-item" *ngFor="let pag of titulo.tipoDeCobranca">
          <div class="pagamento-info">
            <i class="pi pi-calendar"></i>
            <span>{{ formatarVencimento(pag.emissaoMovimento || '') }}</span>
          </div>
          <div class="pagamento-valor">
            {{ formatarValor((pag.valorMovimento || pag.valor), titulo.moeda) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Paginacao -->
<p-paginator
  *ngIf="totalRecords > 0"
  [rows]="rows"
  [totalRecords]="totalRecords"
  [first]="first"
  [rowsPerPageOptions]="[10, 20, 50]"
  (onPageChange)="onPageChange($event)">
</p-paginator>
